<template>
  <div>
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <ProductosDialogVenta ref="productosDialog" @seleccionado="recibirProducto"></ProductosDialogVenta>
      <EditarVentaDialog ref="editarVentaDialog" @actualizado="despuesDeActualizar"></EditarVentaDialog>

      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Ventas</v-toolbar-title>
      </v-toolbar>

      <v-tabs v-model="tab">
        <v-tab href="#one"><v-icon left>mdi-cart-outline</v-icon>Registro</v-tab>
        <v-tab href="#two"><v-icon left>mdi-dns</v-icon>Listado</v-tab>
      </v-tabs>

      <v-tabs-items :value="tab">

        <!-- TAB 1 — REGISTRO -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>

                  <v-col cols="12"><v-sheet color="grey lighten-1" class="pa-3 mt-1"><strong>DATOS DEL COMPROBANTE</strong></v-sheet></v-col>
                  <v-col cols="12" sm="4"><v-text-field v-model="venta.comprobante_numero" label="N° Comprobante" disabled outlined dense hint="Generado automáticamente" persistent-hint></v-text-field></v-col>
                  <v-col cols="12" sm="4"><v-text-field v-model="venta.fecha_registro" label="Fecha de Registro" disabled outlined dense hint="Automático al guardar" persistent-hint></v-text-field></v-col>
                  <v-col cols="12" sm="4"><v-text-field v-model="venta.fecha_documento" label="Fecha de Documento" disabled outlined dense hint="Automático al guardar" persistent-hint></v-text-field></v-col>

                  <v-col cols="12"><v-sheet color="grey lighten-1" class="pa-3 mt-3"><strong>INFORMACIÓN DE LA OPERACIÓN</strong></v-sheet></v-col>
                  <v-col cols="12" sm="6">
                    <v-sheet class="pa-3" elevation="0" outlined rounded>
                      <v-radio-group v-model="venta.condicion" row label="Condición de Pago" :rules="[v => !!v || 'Campo requerido']">
                        <v-radio label="CONTADO" value="CONTADO"></v-radio>
                        <v-radio label="CRÉDITO" value="CREDITO"></v-radio>
                      </v-radio-group>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12" sm="6"><v-textarea v-model="venta.obs" label="Observaciones" outlined dense rows="2" auto-grow></v-textarea></v-col>

                  <v-col cols="12"><v-sheet color="grey lighten-1" class="pa-3 mt-3"><strong>IMPORTES</strong></v-sheet></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field v-model.number="venta.total_excenta" label="Total Exenta" type="number" outlined dense @input="recalcularTotales"></v-text-field></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field v-model.number="venta.total_gravada5" label="Gravada 5%" type="number" outlined dense @input="recalcularTotales"></v-text-field></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field :value="ivaCalculado5" label="IVA 5% (calculado)" type="number" outlined dense disabled></v-text-field></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field v-model.number="venta.total_gravada10" label="Gravada 10%" type="number" outlined dense @input="recalcularTotales"></v-text-field></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field :value="ivaCalculado10" label="IVA 10% (calculado)" type="number" outlined dense disabled></v-text-field></v-col>
                  <v-col cols="12" sm="6" md="3"><v-text-field :value="montoTotalCalculado" label="Monto Total" type="number" outlined dense disabled></v-text-field></v-col>

                  <v-col cols="12"><v-sheet color="grey lighten-1" class="pa-3 mt-3"><strong>DETALLE DE PRODUCTOS</strong></v-sheet></v-col>

                  <v-col cols="12" sm="5">
                    <v-text-field :value="detalleActual.producto ? detalleActual.producto.descripcion : ''" label="Producto seleccionado" outlined dense disabled placeholder="Presione Buscar para seleccionar">
                      <template v-slot:append>
                        <v-btn small color="primary" class="mt-n1" @click="$refs.productosDialog.openDialog()"><v-icon small left>mdi-magnify</v-icon>Buscar</v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2"><v-text-field v-model.number="detalleActual.cantidad" label="Cantidad" type="number" min="1" outlined dense></v-text-field></v-col>
                  <v-col cols="12" sm="3"><v-text-field v-model.number="detalleActual.precio_venta" label="Precio Venta" type="number" min="0" outlined dense></v-text-field></v-col>
                  <v-col cols="12" sm="2" class="d-flex align-center">
                    <v-btn color="primary" outlined @click="agregarDetalle"><v-icon left>mdi-plus</v-icon>Agregar</v-btn>
                  </v-col>

                  <v-col cols="12" v-if="detalles.length > 0">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead><tr><th>Producto</th><th>Cantidad</th><th>Precio Venta</th><th>Subtotal</th><th>Quitar</th></tr></thead>
                        <tbody>
                          <tr v-for="(det, i) in detalles" :key="i">
                            <td>{{ det.producto.descripcion }}</td>
                            <td>{{ det.cantidad }}</td>
                            <td>{{ det.precio_venta }}</td>
                            <td>{{ det.cantidad * det.precio_venta }}</td>
                            <td><v-btn icon small color="red" @click="quitarDetalle(i)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>

                </v-row>

                <v-row class="mt-4">
                  <v-col>
                    <v-btn :disabled="!valid" color="success" class="mr-4" @click="registrar">Registrar</v-btn>
                    <v-btn color="error" class="mr-4" @click="limpiar">Cancelar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-text>
              <v-alert colored-border type="info" elevation="2">
                La fecha, número de comprobante y empresa se asignan automáticamente al registrar.
                Al registrar una venta, el stock de cada producto se descuenta con la cantidad ingresada.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- TAB 2 — LISTADO -->
        <v-tab-item value="two">
          <v-card flat>
            <v-card-text>
              <v-text-field v-model="buscador" placeholder="Ejemplo: 5, 12" outlined>
                <template v-slot:label><v-icon style="vertical-align: middle">mdi-magnify</v-icon>Búsqueda por N° de Comprobante</template>
              </v-text-field>

              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead class="thead-dark">
                    <tr><th>ID</th><th>N° Comprobante</th><th>Condición</th><th>Exenta</th><th>Gravada 5%</th><th>Gravada 10%</th><th>Total</th><th>Fecha Registro</th><th>Editar</th><th>Eliminar</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="venta in ventasBuscadas" :key="venta.id">
                      <td>{{ venta.id }}</td>
                      <td>{{ venta.comprobante_numero }}</td>
                      <td>{{ venta.condicion }}</td>
                      <td>{{ venta.total_excenta }}</td>
                      <td>{{ venta.total_gravada5 }}</td>
                      <td>{{ venta.total_gravada10 }}</td>
                      <td>{{ venta.monto_total }}</td>
                      <td>{{ venta.fecha_registro }}</td>
                      <td><v-btn small color="primary" outlined @click="openEditarVentaDialog(venta)"><v-icon left small>mdi-pencil</v-icon>Editar</v-btn></td>
                      <td><v-btn icon small color="red" @click="eliminarVenta(venta)"><v-icon>mdi-delete-forever</v-icon></v-btn></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import ventaService from '@/services/ventaService';
import ProductosDialogVenta from '@/components/tienda/venta/ProductosDialogVenta.vue';
import EditarVentaDialog from '@/components/tienda/venta/EditarVentaDialog.vue';

export default {
  name: 'RegistroVentaAdmin',
  components: { ProductosDialogVenta, EditarVentaDialog },

  computed: {
    tab: { set(tab) { this.$router.replace({ query: { ...this.$route.query, tab } }); }, get() { return this.$route.query.tab; } },
    ivaCalculado5() { return Math.round((this.venta.total_gravada5 || 0) / 11); },
    ivaCalculado10() { return Math.round((this.venta.total_gravada10 || 0) / 11); },
    montoTotalCalculado() { return parseFloat(this.venta.total_excenta || 0) + parseFloat(this.venta.total_gravada5 || 0) + parseFloat(this.venta.total_gravada10 || 0); },
    ventasBuscadas() { return this.ventas.filter(v => String(v.comprobante_numero).includes(this.buscador)); }
  },

  data() {
    return {
      valid: true, buscador: '', ventas: [],
      venta: { condicion: 'CONTADO', total_excenta: 0, total_gravada5: 0, total_iva5: 0, total_gravada10: 0, total_iva10: 0, monto_total: 0, obs: '', comprobante_numero: '', fecha_registro: '', fecha_documento: '' },
      detalles: [],
      detalleActual: { producto: null, cantidad: 1, precio_venta: 0 },
      mensaje: { snackbar: false, text: '', color: '', timeout: 5000, colorBtn: 'white' }
    };
  },

  mounted() { this.listarVentas(); this.tab = 'two'; },

  methods: {
    recalcularTotales() { this.venta.total_iva5 = this.ivaCalculado5; this.venta.total_iva10 = this.ivaCalculado10; this.venta.monto_total = this.montoTotalCalculado; },

    agregarDetalle() {
      if (!this.detalleActual.producto) { this.mensajeError('Debe seleccionar un producto'); return; }
      if (this.detalleActual.cantidad <= 0) { this.mensajeError('La cantidad debe ser mayor a 0'); return; }
      this.detalles.push({ ...this.detalleActual });
      this.venta.total_gravada10 = this.detalles.reduce((acc, d) => acc + (d.cantidad * d.precio_venta), 0);
      this.recalcularTotales();
      this.detalleActual = { producto: null, cantidad: 1, precio_venta: 0 };
    },

    quitarDetalle(index) {
      this.detalles.splice(index, 1);
      this.venta.total_gravada10 = this.detalles.reduce((acc, d) => acc + (d.cantidad * d.precio_venta), 0);
      this.recalcularTotales();
    },

    recibirProducto(producto) {
      this.detalleActual.producto = producto;
      if (producto.pvu && parseFloat(producto.pvu) > 0) { this.detalleActual.precio_venta = parseFloat(producto.pvu); }
    },

    async registrar() {
      if (!this.$refs.form.validate()) return;
      this.recalcularTotales();
      const payload = {
        venta: { condicion: this.venta.condicion, total_excenta: this.venta.total_excenta, total_gravada5: this.venta.total_gravada5, total_iva5: this.ivaCalculado5, total_gravada10: this.venta.total_gravada10, total_iva10: this.ivaCalculado10, monto_total: this.montoTotalCalculado, obs: this.venta.obs },
        detalles: this.detalles.map(d => ({ producto_id: d.producto.id, cantidad: d.cantidad, precio_venta: d.precio_venta, precio_venta_total: d.cantidad * d.precio_venta }))
      };
      try { await ventaService.save(payload); this.mensajeOk('Venta registrada correctamente'); this.limpiar(); this.listarVentas(); }
      catch (error) { this.mensajeError(error.response?.data?.message || 'Error al registrar'); }
    },

    async eliminarVenta(venta) {
      if (!confirm('¿Desea eliminar la venta N° ' + venta.comprobante_numero + '?')) return;
      try { await ventaService.delete(venta.id); this.mensajeOk('Venta eliminada correctamente'); this.listarVentas(); }
      catch (error) { this.mensajeError('Error al eliminar'); }
    },

    listarVentas() { ventaService.listarVentas().then(res => { this.ventas = res.data.data; }).catch(() => { this.mensajeError('Error al cargar ventas'); }); },

    openEditarVentaDialog(venta) { this.$refs.editarVentaDialog.openDialog(venta); },
    despuesDeActualizar() { this.mensajeOk('Venta actualizada correctamente'); this.listarVentas(); },

    limpiar() {
      this.venta = { condicion: 'CONTADO', total_excenta: 0, total_gravada5: 0, total_iva5: 0, total_gravada10: 0, total_iva10: 0, monto_total: 0, obs: '', comprobante_numero: '', fecha_registro: '', fecha_documento: '' };
      this.detalles = []; this.detalleActual = { producto: null, cantidad: 1, precio_venta: 0 };
      this.$refs.form?.resetValidation();
    },

    mensajeOk(t) { this.mensaje = { snackbar: true, text: t, color: 'success', timeout: 5000, colorBtn: 'white' }; },
    mensajeError(t) { this.mensaje = { snackbar: true, text: t, color: 'error', timeout: 5000, colorBtn: 'white' }; }
  }
};
</script>
